module.exports = "https://images.shiksha.ws/saassets/media/arrow.2143a159.svg";